module.exports = __webpack_public_path__ + "img/img-ab904f3e.9222b658.png";